var React = require('react');
var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var spritesHelper = require('../../../lib/spritesHelper');
var Utils = require('../../../lib/utils');
var Audio = require('../../../lib/audio');

var blobsAnimations = require('../../../animations/blobs');
var commonAnimations = require('../../../animations/common');
var puppetsMasterAnimations = require('../../../animations/puppetsMaster');
var stampGirlAnimations = require('../../../animations/stampGirl');

var Stamper = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        movieclipKey: React.PropTypes.string,
        paintersPaintableBlobsProbabilities: React.PropTypes.object,
        title: React.PropTypes.string,
        role: React.PropTypes.string,
    },

    contextTypes: {
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        cleanTint: React.PropTypes.number,
        dirtyTints: React.PropTypes.array,
        language: React.PropTypes.string,
    },

    sprites: null,
    timeline: null,
    movieclipTimelines: null,
    audios: null,

    getDefaultProps: function()
    {
        return {
            // Texts are modified at the upper level
            movieclipKey: 'stampGirl',
            blobsRow: 1,
            showBottomTreadmill: false,
            paintersPaintableBlobsProbabilities: {
                '1': 3/10,
                '2': 6/10,
                '3': 10/10
            },
            audioUrls: {
                treadmill: '/audio/28nov/titrisation-convoyeur-loop.mp3'
            },
        };
    },

    render: function()
    {
        return (
            <Frame
                {...this.props}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
            />
        );
    },

    build: function(container, timeline)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: true,
                channel: 'frame'
            });
        }, this));

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {
        this.audios.treadmill.play();
    },

    pause: function()
    {
        this.audios.treadmill.pause();
    },

    destroy: function()
    {
        Object.keys(this.audios).forEach((audioKey) => {
            this.audios[audioKey].destroy();
            this.audios[audioKey] = null;
        });

        if (this.sprites) {
            // console.log('kill sprites stamper', this.sprites);
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }

        this.sprites = null;
        this.timeline = null;
        this.audios = null;
        this.movieclipTimelines = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objs = props.objs;
        var container = sprites.container;

        // STAMP
        var stampObj = objs.stamp;
        var stamp = sprites.stamp = createSprite(stampObj);
        Utils.setSizeAndPositionFromRefSize(stamp, props.width, props.height, stampObj);
        container.addChild(stamp);
        stamp.alpha = 0;

        // STAMPER
        spritesHelper.addStamper(props.width, props.height, {
            sprites: sprites,
            objectsWithTextures: props.objs,
            minIntensity: context.minIntensity,
            maxIntensity: context.maxIntensity,
            container: container,
            blobsRow: props.blobsRow,
            showBottomTreadmill: props.showBottomTreadmill,
            stamperMovieclipKey: props.movieclipKey
        });
    },

    animateObjects: function()
    {
        var timeline = this.timeline;

        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;
        var width = props.width;

        var movieclipTimelines = this.movieclipTimelines = [];

        // blobs
        sprites.stampersBlobsGroups.map(function(stamperBlobsGroups, stamperIndex){
            stamperBlobsGroups.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    movieclipTimelines.push(timeline.add(blobsAnimations.getPaintBlobTimeline(blob, {
                        width: width + width * 0.15,
                        cleanTint: context.cleanTint,
                        dirtyTints: context.dirtyTints
                    }), blobGroupIndex * 0.5 + stamperIndex * 0.3));
                });
            });
        });

        // intensity-influenced movieclips
        var i, movieclipProp, movieclip, movieclipObject, intensityMovieclips;
        [props.movieclipKey].map(_.bind(function(intensityMovieclipKey, intensityMovieclipIndex){
            intensityMovieclips = [];
            for (i = context.minIntensity; i <= context.maxIntensity; i++)
            {
                movieclipProp = intensityMovieclipKey+i;
                movieclip = sprites[movieclipProp];
                movieclipObject = objects[movieclipProp];
                movieclip.name = intensityMovieclipKey+i;
                intensityMovieclips.push(movieclip);
            }
            movieclipTimelines.push(timeline.add(commonAnimations.getMovieclipTimeline(intensityMovieclips, {
                fps: 4,
                onFrameUpdate: this.onIntensityMovieclipFrameUpdate
            }), intensityMovieclipIndex * 0.1));
        }, this));

        if (this.props.onAnimationReady)
        {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity : intensity;

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline){
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        // intensity-influenced movieclips
        [props.movieclipKey].map(function(intensityMovieclipKey)
        {
            for (var i = minIntensity; i <= maxIntensity; i++)
            {
                var movieclip = sprites[intensityMovieclipKey+i];
                movieclip.visible = i === intensity;
            }
        });

        // blobs
        var paintersPaintableBlobsProbability = props.paintersPaintableBlobsProbabilities[intensity];
        sprites.stampersBlobsGroups.map(function(blobsGroups, painterIndex){
            blobsGroups.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    blob.paintable = _.random(0, 1, true) < paintersPaintableBlobsProbability;
                });
            });
        });
    },

    onIntensityMovieclipFrameUpdate: function(movieclip)
    {
        var movieclipName = movieclip.name;
        var name = movieclipName.slice(0, -1);
        var intensity = movieclipName.slice(-1);
        var props = this.props;
        var movieclipKey = props.movieclipKey;
        var currentFrame = movieclip.currentFrame;

        if (!movieclip.visible || !props.play)
        {
            return;
        }
        if (movieclipKey === 'puppetsMaster')
        {
            puppetsMasterAnimations.onStomperFrameUpdate(currentFrame, intensity, this.sprites.stamp);
        } else if (movieclipKey === 'stampGirl'){
            stampGirlAnimations.onStomperFrameUpdate(currentFrame, intensity, this.sprites.stamp);
        }

    }

});

module.exports = Stamper;



// WEBPACK FOOTER //
// ./js/components/frames/_common/Stamper.jsx